// src/pages/Universities/Import.jsx
import React, { useState } from 'react';
import { Button, Container, Alert, Form } from 'react-bootstrap';
import { universityAPI } from '../../api/wbuoaApi';

const UniversityImport = () => {
  const [file, setFile] = useState(null);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) {
      setError('Please select a file');
      return;
    }

    setLoading(true);
    setError(null);
    setSuccess(null);

    try {
      await universityAPI.importUniversities(file);
      setSuccess('Universities imported successfully');
    } catch (err) {
      setError('Failed to import universities');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="mt-5" style={{ maxWidth: '500px' }}>
      <h2 className="text-center mb-4">Import Universities</h2>
      {error && <Alert variant="danger">{error}</Alert>}
      {success && <Alert variant="success">{success}</Alert>}
      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <Form.Label>CSV File</Form.Label>
          <Form.Control
            type="file"
            accept=".csv"
            onChange={handleFileChange}
            required
          />
        </Form.Group>
        <Button 
          variant="primary" 
          type="submit" 
          disabled={loading}
          className="w-100"
        >
          {loading ? 'Importing...' : 'Import'}
        </Button>
      </Form>
    </Container>
  );
};

export default UniversityImport;